/**
 * Featured Reviews Data — Diverse Product Categories
 * Mock reviews across Tech, Home, Food, Fitness, Beauty, Fashion, and more
 * These demonstrate what Consensus finds across all editorial sources
 */

export const featuredReviews = [
  // 🖥️ TECH & GADGETS
  {
    id: 'featured-1',
    title: 'MacBook Pro 16" (M3 Max)',
    category: 'tech',
    source: 'tomshardware',
    sourceName: "Tom's Hardware",
    sourceIcon: '🔧',
    rating: 4.7,
    verdict: 'Best laptop for professionals',
    excerpt: 'The M3 Max offers exceptional performance for creative professionals. Battery life is excellent, and the build quality is outstanding.',
    pros: ['Amazing performance', 'Excellent battery life', 'Beautiful display'],
    cons: ['Expensive', 'Limited ports', 'Overkill for basic tasks'],
    url: 'https://www.tomshardware.com',
    sentiment: 'positive',
  },
  {
    id: 'featured-2',
    title: 'Sony WH-1000XM5 Headphones',
    category: 'audio',
    source: 'wirecutter',
    sourceName: 'Wirecutter',
    sourceIcon: '✨',
    rating: 4.8,
    verdict: 'Best noise-canceling headphones',
    excerpt: 'The XM5s deliver industry-leading noise cancellation and excellent sound quality. Comfort is superb for extended wear.',
    pros: ['Best-in-class ANC', 'Excellent sound', 'Premium comfort'],
    cons: ['Very expensive', 'Complex app', 'Heavy for travel'],
    url: 'https://www.nytimes.com/wirecutter',
    sentiment: 'positive',
  },
  {
    id: 'featured-3',
    title: 'ASUS ROG Zephyrus G14',
    category: 'tech',
    source: 'cnet',
    sourceName: 'CNET',
    sourceIcon: '📺',
    rating: 4.5,
    verdict: 'Best gaming laptop for portability',
    excerpt: 'Powerful GPU performance in a compact form factor. The 14-inch display is vibrant and the keyboard is responsive.',
    pros: ['Compact design', 'Powerful GPU', 'Fast refresh rate'],
    cons: ['Runs hot', 'Battery life okay', 'Pricey'],
    url: 'https://www.cnet.com',
    sentiment: 'positive',
  },

  // 🏠 HOME & KITCHEN
  {
    id: 'featured-4',
    title: 'All-Clad HA1',
    category: 'kitchen',
    source: 'serious-eats',
    sourceName: 'Serious Eats',
    sourceIcon: '🍳',
    rating: 4.9,
    verdict: 'Best non-stick cookware set',
    excerpt: 'All-Clad HA1 delivers exceptional performance with PFOA-free non-stick coating. Heat distribution is even and handles high heat well.',
    pros: ['Non-stick excellence', 'Great heat distribution', 'Lifetime warranty'],
    cons: ['Expensive', 'Hand wash recommended', 'Takes time to season'],
    url: 'https://www.seriouseats.com',
    sentiment: 'positive',
  },
  {
    id: 'featured-5',
    title: 'OXO Good Grips Knives',
    category: 'kitchen',
    source: 'americas-test',
    sourceName: "America's Test Kitchen",
    sourceIcon: '👨‍🍳',
    rating: 4.6,
    verdict: 'Best value kitchen knife set',
    excerpt: 'OXO Good Grips offer professional-grade sharpness at reasonable prices. Handles are ergonomic and comfortable for extended use.',
    pros: ['Great value', 'Ergonomic grip', 'Sharp and durable'],
    cons: ['Not for professionals', 'Requires sharpening', 'Plastic handles'],
    url: 'https://www.americastestkitchen.com',
    sentiment: 'positive',
  },
  {
    id: 'featured-6',
    title: 'Herman Miller Aeron Chair',
    category: 'home',
    source: 'architectural-digest',
    sourceName: 'Architectural Digest',
    sourceIcon: '🪑',
    rating: 4.8,
    verdict: 'Best ergonomic office chair',
    excerpt: 'The Aeron chair is the gold standard for ergonomic comfort. Adjustability is unmatched and it\'s built to last decades.',
    pros: ['Excellent ergonomics', 'Fully adjustable', 'Lasts forever'],
    cons: ['Expensive', 'Takes adjustment time', 'Plastic appearance'],
    url: 'https://www.architecturaldigest.com',
    sentiment: 'positive',
  },

  // 👟 FITNESS & SPORTS
  {
    id: 'featured-7',
    title: 'Nike Pegasus 40',
    category: 'fitness',
    source: 'runners-world',
    sourceName: "Runner's World",
    sourceIcon: '👟',
    rating: 4.4,
    verdict: 'Best all-around running shoe',
    excerpt: 'The Pegasus 40 delivers responsive cushioning and reliable performance. Perfect for daily training and easy runs.',
    pros: ['Responsive cushioning', 'Great value', 'Durable'],
    cons: ['Not specialized', 'Narrow fit', 'Break-in period'],
    url: 'https://www.runnersworld.com',
    sentiment: 'positive',
  },
  {
    id: 'featured-8',
    title: 'Garmin Epix Gen 2',
    category: 'fitness',
    source: 'outside-mag',
    sourceName: 'Outside Magazine',
    sourceIcon: '⌚',
    rating: 4.7,
    verdict: 'Best adventure smartwatch',
    excerpt: 'Epix Gen 2 combines rugged durability with beautiful AMOLED display. GPS and outdoor navigation are incredibly accurate.',
    pros: ['Gorgeous display', 'Rugged build', 'Accurate GPS'],
    cons: ['Battery drain on display', 'Expensive', 'Overkill for casual use'],
    url: 'https://www.outsideonline.com',
    sentiment: 'positive',
  },

  // 💄 BEAUTY & PERSONAL CARE
  {
    id: 'featured-9',
    title: 'Olay Regenerist Eye Cream',
    category: 'beauty',
    source: 'allure',
    sourceName: 'Allure',
    sourceIcon: '✨',
    rating: 4.3,
    verdict: 'Best affordable eye cream',
    excerpt: 'Olay Regenerist delivers visible results without the luxury price tag. Fine lines diminish and skin feels hydrated all day.',
    pros: ['Affordable', 'Effective', 'Lightweight texture'],
    cons: ['Not for very sensitive skin', 'Slow results', 'Packaging could be better'],
    url: 'https://www.allure.com',
    sentiment: 'positive',
  },
  {
    id: 'featured-10',
    title: 'Dyson Supersonic Hair Dryer',
    category: 'beauty',
    source: 'refinery29',
    sourceName: 'Refinery29',
    sourceIcon: '💇',
    rating: 4.6,
    verdict: 'Best premium hair dryer',
    excerpt: 'The Dyson Supersonic dries hair in half the time with intelligent heat control. Your hair will thank you.',
    pros: ['Fast drying', 'Hair stays shiny', 'Cool design'],
    cons: ['Very expensive', 'Loud', 'Cord management'],
    url: 'https://www.refinery29.com',
    sentiment: 'positive',
  },

  // 👗 FASHION & APPAREL
  {
    id: 'featured-11',
    title: 'Levi\'s 501 Jeans',
    category: 'fashion',
    source: 'gq',
    sourceName: 'GQ',
    sourceIcon: '👖',
    rating: 4.5,
    verdict: 'Timeless denim that never goes out of style',
    excerpt: 'The 501 is the quintessential jean. Classic fit, quality denim, and they only get better with age.',
    pros: ['Timeless style', 'Great quality', 'Affordable classic'],
    cons: ['Break-in period', 'Limited stretch', 'Sizing inconsistent'],
    url: 'https://www.gq.com',
    sentiment: 'positive',
  },

  // 🎮 GAMING
  {
    id: 'featured-12',
    title: 'PlayStation 5',
    category: 'gaming',
    source: 'ign',
    sourceName: 'IGN',
    sourceIcon: '🎮',
    rating: 4.7,
    verdict: 'Best next-gen console',
    excerpt: 'PS5 delivers stunning graphics and blazingly fast load times. The controller features are innovative and immersive.',
    pros: ['Powerful performance', 'Exclusive games', 'Fast SSD'],
    cons: ['Hard to find', 'Expensive', 'Limited next-gen titles'],
    url: 'https://www.ign.com',
    sentiment: 'positive',
  },

  // 📷 PHOTOGRAPHY
  {
    id: 'featured-13',
    title: 'Sony A7R V',
    category: 'camera',
    source: 'dpreview',
    sourceName: 'DPReview',
    sourceIcon: '📷',
    rating: 4.8,
    verdict: 'Best mirrorless camera for professionals',
    excerpt: 'The A7R V offers 61MP resolution with incredible detail. Autofocus is industry-leading.',
    pros: ['61MP sensor', 'Advanced AF', 'Build quality'],
    cons: ['Expensive', 'File sizes huge', 'Needs fast SD cards'],
    url: 'https://www.dpreview.com',
    sentiment: 'positive',
  },

  // 🚗 AUTOMOTIVE
  {
    id: 'featured-14',
    title: 'Tesla Model 3',
    category: 'auto',
    source: 'caranddriver',
    sourceName: 'Car and Driver',
    sourceIcon: '🚗',
    rating: 4.4,
    verdict: 'Best affordable electric car',
    excerpt: 'Model 3 combines excellent performance with practical range. Charging infrastructure makes it viable for daily use.',
    pros: ['Fast acceleration', 'Great range', 'Low maintenance'],
    cons: ['Expensive', 'Autopilot concerns', 'Build quality'],
    url: 'https://www.caranddriver.com',
    sentiment: 'positive',
  },
];

/**
 * Get featured reviews for today
 * Uses date-based seeding so same reviews show all day
 * Resets at midnight UTC
 */
export function getFeaturedReviewsForToday() {
  // Get today's date (UTC) as a seed
  const today = new Date();
  const seed = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();

  // Simple seeded shuffle (deterministic based on date)
  const shuffled = [...featuredReviews].sort((a, b) => {
    const hashA = (seed + parseInt(a.id.replace(/\D/g, ''))) % 1000;
    const hashB = (seed + parseInt(b.id.replace(/\D/g, ''))) % 1000;
    return hashA - hashB;
  });

  // Return top 3 for the hero section
  return shuffled.slice(0, 3);
}

/**
 * Get featured reviews by category
 */
export function getFeaturedReviewsByCategory(category) {
  return featuredReviews.filter(r => r.category === category);
}

/**
 * Get all unique categories
 */
export function getCategories() {
  return [...new Set(featuredReviews.map(r => r.category))];
}

/**
 * Get a random review (truly random, not seeded)
 */
export function getRandomReview() {
  return featuredReviews[Math.floor(Math.random() * featuredReviews.length)];
}
